import React from 'react'
import InformationUserContainer from "../../InformationUserContainer"

function InformationContainer(props) {
    return (
        <div className="InformationContainer">
            <InformationUserContainer isActive="information">
                <div className="PageHeading HasDescription">
                    <h1 className="PageTitle">Thông tin</h1>
                    <p className="Description">Thông tin user đang đăng nhập</p>
                </div>
            </InformationUserContainer>
        </div>
    )
}

export default InformationContainer